module.exports = __webpack_public_path__ + "static/media/maps-map.f4e6d5fa.png";